import React, { Component } from 'react';
import {BeautifulCircleIcon} from './BeautifulCircleIcon';



export class TgbotTokenPage extends React.Component {

    constructor(props) {
        super(props);
        console.log(this.props.data)
    }

    render() {
        return (
            
            
                <div className="createPage_whiteBlock">
                   
                        <div className='whiteBlockTitle'>
                        <BeautifulCircleIcon/>
                            <div className='whiteBlockTitleSpan'>
                                Введите токен бота
                            </div>
                        </div>
                        <div className='whiteBlockMiddle'>
                        
                        <input onChange={this.props.updateBotToken} type='text' value={this.props.bot_token} />
                        
                          </div>    
                            

                        <div className='whiteBlockButtonBlock'  style={{paddingLeft: 0}}>
                            <a href='#' className="whiteBlockButton" onClick={()=> {
                                this.props.verifyBot()
                            }}>Продолжить</a>
                        </div>
                        </div>
    
        
            
        )
    }
}